module.exports = __webpack_public_path__ + "static/media/Icon awesome-gamepad.51738763.svg";